export default (src: string, width: string | number, height: string | number) => {
  const { baseUrl, cloudflare } = useRuntimeConfig().public
  let img = src
  if (!(cloudflare && process.env.NODE_ENV === 'production')) {
    return img
  }
  if (src.charAt(0) === '/') {
    img = `${baseUrl}${src}`
  }
  return `${cloudflare}/cdn-cgi/image/w=${width},h=${height},fit=cover,f=auto/${img}`
}
